export default __webpack_public_path__ + "static/1_StaffPage_Banner-e50604358f70a5786a6d22b02462d11a.jpg";